
import memoizeOne from 'memoize-one';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import PropTypes from 'prop-types';
import React from 'react';
import Switch from '@material-ui/core/Switch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';

class UserTable extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = this.getStateFromLocalStorage() || {
            blackList: { _id: true, password: true },
        };
    }

    componentDidUpdate() {
        this.saveStateToLocalStorage();
    }

    getStateFromLocalStorage() {
        const text = window.localStorage.getItem('React.FindUser.UserTable.State');
        if (!text) {
            return null;
        }
        return JSON.parse(text);
    }

    saveStateToLocalStorage() {
        window.localStorage.setItem('React.FindUser.UserTable.State', JSON.stringify(this.state));
    }

    handleShowMore = memoizeOne(info => () => {
        window.open(`/user/${info._id}`, "_blank");
    });

    toggleBlackList = name => event => {
        this.setState({ blackList: { ...this.state.blackList, [name]: !event.target.checked } });
    }

    render() {
        const columns = {};
        for (let item of this.props.results) {
            for (let key in item) {
                if (typeof item[key] === 'number' ||
                    typeof item[key] === 'string' ||
                    typeof item[key] === 'boolean') {
                    if (!columns[key] && key !== "_id") {
                        columns[key] = { title: key, field: key, type: typeof item[key] };
                    }
                }
            }
        }
        const headers = Object.keys(columns).filter(key => !this.state.blackList[key]).map(key => columns[key]);
        return <div>
            <h4>Total Users Found: {this.props.count}, Displaying: {this.props.results.length}</h4>
            <div>
                {Object.keys(columns).map(key => (
                    <FormControlLabel key={columns[key].field}
                        control={
                            <Checkbox checked={!this.state.blackList[key]} onChange={this.toggleBlackList(key)} />
                        }
                        label={key}
                    />
                ))}
            </div>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Id</TableCell>
                        {
                            headers.map(item => (<TableCell key={item.field} align="right">{item.title}</TableCell>))
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.props.results.map(row => (
                        <TableRow hover key={row._id} className="mouse_hover" onClick={this.handleShowMore(row)}>
                            <TableCell component="th" scope="row">{row._id}</TableCell>
                            {
                                headers.map(item => (<TableCell key={item.field} align="right">{item.type === "boolean" ? (row[item.field] ? 'true' : 'false') : row[item.field]}</TableCell>))
                            }
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>;
    }
}

UserTable.propTypes = {
    count: PropTypes.number.isRequired,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default class FindUser extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = this.getStateFromLocalStorage() || {
            useId: true,
            useName: false,
            useTag: false,
            useGold: false,
            useGems: false,
            id: '',
            name: '',
            tag: '',
            gold: 0,
            gems: 0,
            advance: false,
            advanceQuery: '{gems: {$gt: 100}}',
            advanceSort: '{gems: -1}',
        };
        Object.assign(this.state, {
            searching: false,
            searchResult: {
                error: null,
                count: -1,
                results: [],
            },
        });
    }

    componentDidUpdate() {
        this.saveStateToLocalStorage();
    }

    getStateFromLocalStorage() {
        const text = window.localStorage.getItem('React.FindUser.State');
        if (!text) {
            return null;
        }
        return JSON.parse(text);
    }

    saveStateToLocalStorage() {
        window.localStorage.setItem('React.FindUser.State', JSON.stringify(this.state));
    }

    handleCheckBox = name => event => {
        this.setState({ [name]: event.target.checked });
    }

    handleTextField = name => event => {
        this.setState({ [name]: event.target.value });
    }

    handleUpperTextField = name => event => {
        this.setState({ [name]: event.target.value.toUpperCase() });
    }

    toggleAdvance = event => {
        this.setState({ advance: event.target.checked });
        if (event.target.checked) {
            this.setState({ advanceQuery: JSON.stringify(this.createQuery()) });
        }
    }

    createQuery() {
        const query = {};
        if (this.state.useId) {
            query._id = { "$eq": this.state.id };
        }
        if (this.state.useName) {
            query.name = { $eq: this.state.name };
        }
        if (this.state.useTag) {
            query.tag = { $eq: this.state.tag };
        }
        if (this.state.useGold) {
            query.gold = { "$eq": this.state.gold | 0 };
        }
        if (this.state.useGems) {
            query.gems = { "$eq": this.state.gems | 0 };
        }
        return query;
    }

    onSearch = () => {
        this.setState({ searching: true });

        const query = this.state.advance ? eval(`(${this.state.advanceQuery})`) : this.createQuery();
        const sort = this.state.advance ? eval(`(${this.state.advanceSort})`) : null;
        fetch(`/api/data/user/search`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ query, sort }),
        }).then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ searching: false, searchResult: { error: result.error, count: -1 } });
                } else {
                    this.setState({ searching: false, searchResult: { count: result.count, results: result.results } });
                }
            });
    }

    render() {
        let valid = true;
        let reason = '';
        if (this.state.advance) {
            if (this.state.advanceQuery) {
                try {
                    const query = eval(`(${this.state.advanceQuery})`);
                    if (typeof query !== 'object') {
                        valid = false;
                        reason = reason || 'Expecting an object instead of ' + (typeof query) + ': ' + this.state.advanceQuery;
                    }
                } catch (err) {
                    valid = false;
                    reason = reason || err.message;
                }
            } else {
                valid = false;
                reason = reason || 'Must have a query.';
            }
            if (this.state.advanceSort) {
                try {
                    const query = eval(`(${this.state.advanceSort})`);
                    if (typeof query !== 'object') {
                        valid = false;
                        reason = reason || 'Expecting an object instead of ' + (typeof query) + ': ' + this.state.advanceSort;
                    }
                } catch (err) {
                    valid = false;
                    reason = reason || err.message;
                }
            } else {
                valid = false;
                reason = reason || 'Must have a sort string.';
            }
        } else {
            if (this.state.useId && !this.state.id) {
                valid = false;
                reason = 'Id must not be empty';
            }
            const query = this.createQuery();
            if (Object.keys(query).length === 0) {
                valid = false;
                reason = reason || 'Must specify at least 1 search criteria';
            }
        }
        return (<div>
            <h3>Find User</h3>
            <div style={{ display: 'flex' }}>
                <div style={{ flexShrink: 0 }}>
                    <FormControlLabel
                        control={
                            <Checkbox checked={this.state.advance} onChange={this.toggleAdvance} />
                        }
                        label="Advanced mode (mongo query)"
                    />
                    {
                        this.state.advance &&
                        <div>
                            <div>
                                Query:
                    <textarea rows={10} cols={50} value={this.state.advanceQuery} onChange={this.handleTextField('advanceQuery')} />
                            </div>
                            <div>
                                Sort:
                    <textarea rows={10} cols={50} value={this.state.advanceSort} onChange={this.handleTextField('advanceSort')} />
                            </div>
                        </div>
                    }
                    {
                        !this.state.advance &&
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <TextField disabled={!this.state.useId} label="Id" value={this.state.id} onChange={this.handleTextField('id')} />
                                    </td>
                                    <td>
                                        <Switch checked={this.state.useId} onChange={this.handleCheckBox('useId')} color="primary" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <TextField disabled={!this.state.useName} label="Name" value={this.state.name} onChange={this.handleTextField('name')} />
                                    </td>
                                    <td>
                                        <Switch checked={this.state.useName} onChange={this.handleCheckBox('useName')} color="primary" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <TextField disabled={!this.state.useTag} label="Tag" value={this.state.tag} onChange={this.handleUpperTextField('tag')} />
                                    </td>
                                    <td>
                                        <Switch checked={this.state.useTag} onChange={this.handleCheckBox('useTag')} color="primary" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <TextField disabled={!this.state.useGold} label="Gold" value={this.state.gold} onChange={this.handleTextField('gold')} />
                                    </td>
                                    <td>
                                        <Switch checked={this.state.useGold} onChange={this.handleCheckBox('useGold')} color="primary" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <TextField disabled={!this.state.useGems} label="Gems" value={this.state.gems} onChange={this.handleTextField('gems')} />
                                    </td>
                                    <td>
                                        <Switch checked={this.state.useGems} onChange={this.handleCheckBox('useGems')} color="primary" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    }
                    <FormHelperText error>{reason}</FormHelperText>
                    <Button disabled={!valid || this.state.searching} variant="contained" onClick={this.onSearch}>
                        Search
                {this.state.searching && <CircularProgress size={24} style={{ position: 'absolute', top: '50%', left: '50%', marginTop: -12, marginLeft: -12 }} />}
                    </Button>
                    <FormHelperText error={!!this.state.searchResult.error}>{this.state.searchResult.error}</FormHelperText>
                </div>
                <div style={{ flexGrow: 1 }}>
                    {
                        !this.state.searching && this.state.searchResult.count >= 0 &&
                        <UserTable count={this.state.searchResult.count} results={this.state.searchResult.results} />
                    }
                </div>
            </div>
        </div>);
    }
}
